import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { SiteGroupsState, SiteGroupsStore } from './site-groups.store';

@Injectable({ providedIn: 'root' })
export class SiteGroupsQuery extends QueryEntity<SiteGroupsState> {
  protected store: SiteGroupsStore;

  constructor() {
    const store = inject(SiteGroupsStore);

    super(store);

    this.store = store;
  }
}
